import styled, { css } from "styled-components";

const CSSAppearanceDefault = css`
    background: transparent;
    border-color: #1122;
    color: #334;

    &:not([href]) {
        opacity: .7;
    }

    &[href] {
        &:hover {
            background: #0001;
            border-color: transparent;
        }

        &:active {
            background: #0002;
            border-color: transparent;
        }
    }
`;

const CSSAppearancePrimary = css`
    background: royalblue;
    border-color: transparent;
    color: #fff;

    &:not([href]) {
        opacity: .7;
    }

    &[href] {
        &:hover {
            background: #35d;
        }

        &:active {
            background: #14d;
        }
    }
`;

const CSSAppearanceSubtle = css`
    background: transparent;
    border-color: transparent;
    color: #334;

    &:not([href]) {
        opacity: .7;
    }

    &[href] {
        &:hover {
            background: #0001;
        }

        &:active {
            background: #0002;
        }
    }
`;

const APPEARANCE = {
    default: CSSAppearanceDefault,
    primary: CSSAppearancePrimary,
    subtle: CSSAppearanceSubtle,
};

const CSSSizeDefault = css`
    padding: 6px 12px;
`;

const CSSSizeLarge = css`
    padding: 12px 24px;
`;

const CSSSizeSmall = css`
    padding: 2px 6px;
`;

const SIZE = {
    default: CSSSizeDefault,
    large: CSSSizeLarge,
    small: CSSSizeSmall,
};

interface IAProps {
    $appearance?: "default" | "primary" | "subtle"
    $size?: "default" | "large" | "small"
}

export default styled.button<IAProps>`
    border: 1px solid;
    border-radius: 4px;
    font-weight: 500;
    outline-color: transparent;
    text-decoration: none;
    transition: 200ms;
    white-space: nowrap;
    width: min-content;

    &[href] {
        cursor: pointer;
    }

    &:focus-visible {
        outline: 2px solid royalblue;
        outline-offset: 2px;
    }

    ${ ({ $appearance }) => APPEARANCE[$appearance] ?? APPEARANCE.default };
    ${ ({ $size }) => SIZE[$size] ?? SIZE.default };
`;
